export const getReceptionSeal = (result) => {
  if (!result || typeof result !== 'object') return '';

  const seal = result.selloRecepcion ?? result.selloRecibido ?? result.sello_recepcion ?? '';
  return typeof seal === 'string' ? seal.trim() : '';
};

export const normalizeMhObservations = (observations) => {
  if (Array.isArray(observations)) return observations.filter(Boolean);
  if (observations === null || observations === undefined || observations === '') return [];
  return [String(observations)];
};
